import React from 'react';
import { Box, Typography } from '@mui/material';

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 8,
      px: 2,
      textAlign: 'center',
      color: 'text.secondary',
    }}
  >
    <Box sx={{ fontSize: 64, mb: 2 }}>{icon}</Box>
    <Typography variant="h6" gutterBottom>{title}</Typography>
    {description && <Typography variant="body2" sx={{ mb: 2 }}>{description}</Typography>}
    {action}
  </Box>
);

export default EmptyState; 